import {
  Button,
  Drawer,
  Space,
  Table,
  Card,
  Descriptions,
  Divider,
  Form,
  Input,
  message,
  Modal,
  PageHeader,
  Spin,
} from "antd";
import React from "react";
import { LanguageContext } from "../../context/LanguageContext";
import moment from "moment";
import { gangDetectionAction } from "../../_actions/gang.detection.actions";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { ViewGunaDetails } from "../viewGunaDetails/viewGunaDetails";
class GangListMemo extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.updateFormRef = React.createRef();
    this.state = {
      setCriminalViewModel: false,
      pagination: {
        current: 1,
        pageSize: 10,
      },
      viewGang: false,
      gangeId: "",
      showDetails: [],
      loader: false,
      updateDetail: false,
      updateData: "",
      fir_no: "",
      redirectToGraph: false,
      firToRedirect: null,
      showGunaDetails: false,
    };
  }

  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  onViewAccusedForm = (data) => {
    if (data) {
      this.showCriminalViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };
  onViewGang = (id) => {
    this.setState({ viewGang: true }, () => {
      this.getGangDetails(id);
    });
  };

  closeViewGage = () => {
    this.setState({ viewGang: false });
  };

  onUpdateDetails = (data) => {
    this.setState(
      {
        updateDetail: true,
        updateData: data,
      },
      () => {
        // Set form values immediately after state updates
        this.updateFormRef.current?.setFieldsValue({
          gang_name: data?.gang_name || "",
        });
      }
    );
  };
  closeUpdateDetails = () => {
    this.setState({ updateDetail: false });
  };
  getGangDetails = (id) => {
    this.setState({
      loader: true,
    });
    const temp = {
      gang_id: id,
    };
    gangDetectionAction.getGangDetails(temp).then((res) => {
      console.log("res", res.data.gang);
      this.setState({
        showDetails: res.data.gang,
        loader: false,
      });
    });
  };
  handleUpdate = () => {
    const { updateData } = this.state;
    const { user } = this.props;
    console.log("user", user);

    this.updateFormRef.current
      .validateFields()
      .then((values) => {
        console.log("Validated Data:", values);

        let gangs = {
          gangs: [
            {
              gang_id: updateData.gang_id,
              gang_name: values.gang_name,
              updated_by_user: this.props.user.id,
              gang_leader_id: updateData.gang_leader_id,
              is_active: updateData.is_active,
            },
          ],
        };

        gangDetectionAction.updateGang(gangs).then((res) => {
          message.success("Updated Successfully");
          this.closeUpdateDetails();
          this.props.getGangPaginate();
        });
      })
      .catch((error) => {
        console.log("Validation Failed:", error);
      });
  };

  showGunaViewModel = () => {
    this.setState({
      showGunaDetails: true,
    });
  };

  closeGunaViewModel = () => {
    this.setState({
      showGunaDetails: false,
    });
  };

  onGunaForm = (data) => {
    if (data) {
      this.setState({ gunaLoading: true });
      this.showGunaViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };
  componentDidUpdate(prevProps) {
    // Check if the data has just arrived
    const prevList = prevProps.professionals?.criminalViewList?.gunhaInfor;
    const currList = this.props.professionals?.criminalViewList?.gunhaInfor;
    if (this.state.gunaLoading && prevList !== currList) {
      this.setState({ gunaLoading: false });
    }
    const prevPrevetive = prevProps.professionals?.criminalViewList;
    const currtPrevetive = this.props.professionals?.criminalViewList;
    if (this.state.preventiveLoading && prevPrevetive !== currtPrevetive) {
      this.setState({ preventiveLoading: false });
    }
  }
  componentDidMount() {
    this.props.dispatch(professionalAction.getCrimeTitle());
  }
  render() {
    console.log("fir_no", this.state.fir_no);
    const { professionals, user } = this.props;
    const { pagination, showDetails, updateData } = this.state;
    const { t } = this.context;
    console.log("show details", showDetails);

    let columnsOb = [
      {
        title: t("sr.no"),
        key: "sr.no",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.srNo}
          </Space>
        ),
      },
      {
        title: t("gang_name"),
        key: "gang_name",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.gang_name}
          </Space>
        ),
      },
      //   {
      //     title: "Member Count",
      //     key: "member_count",
      //   },
      {
        title: t("total_accused_count"),
        key: "total_criminals",
        render: (text, record) => (
          <Button
            type="primary"
            shape="circle"
            size="small"
            style={{
              width: 36,
              height: 36,
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
            onClick={() => {
              this.onViewGang(record.gang_id);
            }}
          >
            {record?.total_criminals}
          </Button>
        ),
      },
      {
        title: t("last_update"),
        key: "updated_at",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {moment(record.updated_at).format("DD-MM-YYYY")}
          </Space>
        ),
      },

      {
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.onUpdateDetails(record);
              }}
            >
              {t("update")}
            </Button>
          </div>
        ),
      },
    ];

    let tebleData =
      this.props.data &&
      this.props.data.map((item, index) => {
        return {
          ...item,
          srNo: index + 1,
        };
      });
    console.log("update data", updateData);
    return (
      <>
        <Table
          bordered
          columns={columnsOb}
          dataSource={tebleData}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
          }}
          onChange={this.handleTableChange}
          loading={this.props.loading}
        />
        <Drawer
          title={`Gang Name: ${showDetails?.gang_name || ""}`}
          top
          visible={this.state.viewGang}
          onOk={this.closeViewGage}
          onClose={this.closeViewGage}
          placement="right"
          width={720}
          footer={
            <div style={{ textAlign: "right" }}>
              <Button onClick={this.closeViewGage} style={{ marginRight: 8 }}>
                Cancel
              </Button>
            </div>
          }
        >
          <Spin spinning={this.state.loader}>
            <PageHeader ghost={false} onBack={false}>
              {showDetails &&
                showDetails.members &&
                showDetails.members.length > 0 && (
                  <>
                    <div
                      className="ant-table-wrapper"
                      style={{ overflowX: "auto" }}
                    >
                      <table
                        className="ant-table ant-table-bordered"
                        style={{
                          border: "1px solid rgb(26, 20, 20)",
                          width: "100%",
                        }}
                      >
                        <thead className="ant-table-thead">
                          <tr>
                            <th
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {t("sr.no")}
                            </th>
                            <th
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {t("name")}
                            </th>
                            <th
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {t("police_station")}
                            </th>
                            <th
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {t("total_crimes")}
                            </th>
                            <th
                              className="ant-table-cell"
                              style={{ border: "1px solid rgb(26, 20, 20)" }}
                            >
                              {t("action")}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="ant-table-tbody">
                          {showDetails.members.map((member, index) => (
                            <>
                              <tr key={index}>
                                <td
                                  className="ant-table-cell"
                                  style={{
                                    border: "1px solid rgb(26, 20, 20)",
                                  }}
                                >
                                  {index + 1}
                                </td>
                                <td
                                  className="ant-table-cell"
                                  title={member.criminal_id}
                                  style={{
                                    border: "1px solid rgb(26, 20, 20)",
                                  }}
                                >
                                  {member.name}
                                </td>
                                <td
                                  className="ant-table-cell"
                                  style={{
                                    border: "1px solid rgb(26, 20, 20)",
                                  }}
                                >
                                  {member.districtname}
                                </td>
                                <td
                                  className="ant-table-cell"
                                  style={{
                                    border: "1px solid rgb(26, 20, 20)",
                                  }}
                                >
                                  <Button
                                    type="primary"
                                    shape="circle"
                                    size="small"
                                    style={{
                                      width: 36,
                                      height: 36,
                                      fontWeight: 600,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                    }}
                                    onClick={() => {
                                      this.onGunaForm(member.criminal_id);
                                    }}
                                    disabled={!member?.name}
                                  >
                                    {member.total_crimes}
                                  </Button>
                                </td>
                                <td
                                  className="ant-table-cell"
                                  style={{
                                    border: "1px solid rgb(26, 20, 20)",
                                  }}
                                >
                                  <Button
                                    type="text"
                                    size="small"
                                    className="action-link update-link"
                                    onClick={() => {
                                      this.onViewAccusedForm(
                                        member.criminal_id
                                      );
                                    }}
                                    disabled={!member?.name}
                                  >
                                    {t("view1")}
                                  </Button>
                                </td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
            </PageHeader>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Button
                type="primary"
                onClick={() => {
                  const fir = showDetails?.fir[0];
                  const id = showDetails?.gang_id;
                  if (fir) {
                    window.open(`/graph/${id}`, "_blank");
                  }
                }}
              >
                Graph
              </Button>
            </div>
          </Spin>
        </Drawer>
        <Drawer
          title={this.state.updateData?.gang_name || "Update Gang"}
          placement="right"
          width={720}
          closable={true}
          onClose={this.closeUpdateDetails}
          visible={this.state.updateDetail}
          footer={
            <div style={{ textAlign: "right" }}>
              <Button
                onClick={this.closeUpdateDetails}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              <Button type="primary" onClick={this.handleUpdate}>
                Update
              </Button>
            </div>
          }
        >
          <Form layout="vertical" ref={this.updateFormRef}>
            <Form.Item
              label="Gang Name"
              name="gang_name"
              rules={[{ required: true, message: "Gang name is required" }]}
            >
              <Input placeholder="Enter gang name" />
            </Form.Item>
          </Form>
        </Drawer>
        <Modal
          title="आरोपी प्रोफाइल"
          top
          visible={this.state.setCriminalViewModel}
          onOk={this.closeCriminalViewModel}
          onCancel={this.closeCriminalViewModel}
          width={95 + "%"}
        >
          <ViewFormModel
            key={this.props && this.props.user.id}
            dataStates={this.props.professionals}
          ></ViewFormModel>
        </Modal>
        <Modal
          title={t("crime_information")}
          top
          visible={this.state.showGunaDetails}
          onOk={this.closeGunaViewModel}
          onCancel={this.closeGunaViewModel}
          width={95 + "%"}
        >
          <ViewGunaDetails
            pc_crimetitles={professionals?.pc_crimetitles}
            dataStates={
              Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
              professionals?.criminalViewList?.gunhaInfor.length > 0
                ? professionals?.criminalViewList?.gunhaInfor
                : []
            }
            name={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].name
                : ""
            }
            address={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].address
                : ""
            }
            loading={this.state.gunaLoading}
            user_details={this.props?.user}
            masterId={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].id
                : ""
            }
            closeGunaViewModel={this.closeGunaViewModel}
          ></ViewGunaDetails>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedGangList = connect(mapStateToProps)(GangListMemo);
export { connectedGangList as GangList };
